import { Grid } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { type IntlFormatters } from 'react-intl';
import * as Yup from 'yup';

import { TextDetailEditable } from '../fields';

import { CustomSimpleDialog } from './CustomSimpleDialog';

interface EditNameDialogProps {
  dialogTitle: string;
  fieldTitle: string;
  initialName: string;
  open: boolean;
  formatMessage: IntlFormatters['formatMessage'];
  onClose: () => void;
  setNewName: (name: string) => Promise<void>;
}

interface EditNameFormValues {
  name: string;
}

const EditNameSchema = Yup.object().shape({
  name: Yup.string().min(1).required(),
});

export const EditNameDialog: React.FC<EditNameDialogProps> = ({
  dialogTitle,
  fieldTitle,
  initialName,
  open,
  formatMessage,
  onClose,
  setNewName,
}) => {
  const handleEdit = async (values: EditNameFormValues) => {
    const { name } = values;
    if (initialName !== name) {
      await setNewName(name);
    }
    onClose();
  };

  const initialValues = { name: initialName };

  return (
    <Formik initialValues={initialValues} onSubmit={handleEdit} validationSchema={EditNameSchema}>
      {({ isSubmitting, handleSubmit }) => (
        <Form>
          <CustomSimpleDialog
            open={open}
            onClose={onClose}
            onActionButtonClick={handleSubmit}
            actionButtonLabel={formatMessage({
              id: 'save',
            })}
            actionButtonLoading={isSubmitting}
            dividerBelowTitle
            title={dialogTitle}
            formatMessage={formatMessage}
          >
            <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}>
              <TextDetailEditable
                name="name"
                title={fieldTitle}
                type="text"
                editMode
                style={{ width: 580, maxWidth: 'none' }}
              />
            </Grid>
          </CustomSimpleDialog>
        </Form>
      )}
    </Formik>
  );
};
